import { definePreset } from "@primeng/themes";
import Lara from "@primeng/themes/lara";

export const YmLaraPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: "#e0e9f8",
      100: "#c9d4f5",
      200: "#a2a8f4",
      300: "#9197f6",
      400: "#858bf5",
      500: "#797ef5",
      600: "#5d52d9",
      700: "#4c41bf",
      800: "#2e2a8c",
      900: "#141b4d",
      950: "#0d1233",
    },
    colorScheme: {
      light: {
        primary: {
          color: "{primary.500}",
          contrastColor: "#ffffff",
          hoverColor: "{primary.700}",
          activeColor: "{primary.700}",
        },
        highlight: {
          background: "{primary.50}",
          focusBackground: "{primary.100}",
          color: "{primary.700}",
          focusColor: "{primary.800}",
        },
      },
    },
  },
  components: {
    select: {
      option: {
        focusBackground: "{highlight.background}",
        focusColor: "{highlight.color}",
      },
    },
  },
}) as Record<string, unknown>;
